import { render, staticRenderFns } from "./Failure.vue?vue&type=template&id=286260c3&scoped=true&"
import script from "./Failure.vue?vue&type=script&lang=js&"
export * from "./Failure.vue?vue&type=script&lang=js&"
import style0 from "./Failure.vue?vue&type=style&index=0&id=286260c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286260c3",
  null
  
)

export default component.exports